// extracted by mini-css-extract-plugin
export default {"PFSFooterBranding":"PFSFooterBranding_PFSFooterBranding__gnLT7","BrandingSection":"PFSFooterBranding_BrandingSection__pZvB2"};